import { observer } from "mobx-react-lite";
import { Message, Segment, Table } from "semantic-ui-react";
import { useAgeReadyContext } from "../../../AgeReadyContext/AgeReadyContext";
import React, { useState } from "react";
import DocumentRow from "./DocumentRow";
import styles from "./Documents.module.css"

interface DocumentTableProps {  
  docInfoItems: Array<any>;
  tableHeaders: Array<string>;
  loadingBtn: string;
  setTableBtnLoading: (btn: string) => void;
  deleteDoc: (docId: string, docName: string, caregiverId: string, recipientId: string) => void;
  downloadDoc: (docId: string, docName: string, caregiverId: string, recipientId: string, docType: string) => void;
}

const DocumentTable: React.FC<DocumentTableProps> = (props) => {
  const { docInfoItems, tableHeaders, loadingBtn, setTableBtnLoading, deleteDoc, downloadDoc } = props;
  const { documentInfoStore } = useAgeReadyContext();
  const [ selectedRowDocId, setSelectedRowDocId ] = useState('');
  
  const downloadDocument = (docId: string, docName: string, caregiverId: string, recipientId: string, docType: string) => {
    documentInfoStore.setTableMessage("");
    setTableBtnLoading("download");
    setSelectedRowDocId(docId);
    downloadDoc(docId, docName, caregiverId, recipientId, docType);
  };
  const deleteDocument = (docId: string, docName: string, caregiverId: string, recipientId: string) => {
    documentInfoStore.setTableMessage("");
    setTableBtnLoading("delete");
    setSelectedRowDocId(docId);
    deleteDoc(docId, docName, caregiverId, recipientId);
  };
  
  const renderTableMessage = () => {
    const messageColor = documentInfoStore.tableMessage.toLowerCase().includes("error") ? "red" : "blue";
    const messageIcon = documentInfoStore.tableMessage.toLowerCase().includes("error") ? "warning sign" : "checkmark";

    return (
      <> 
        <Message floating color={messageColor} icon={messageIcon} >
          <label>{documentInfoStore.tableMessage}</label>
        </Message>
      </>
    )
  }

  return (
    <>
     <Segment raised className={styles.docFileRowSeg} > 
     {!!documentInfoStore.tableMessage && renderTableMessage()}
      <Table celled striped selectable unstackable >
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell style={{ width: "60px" }} >{tableHeaders[0]}</Table.HeaderCell>
            <Table.HeaderCell style={{ width: "63%" }} >{tableHeaders[1]}</Table.HeaderCell>
            <Table.HeaderCell style={{ width: "25%" }} >{tableHeaders[3]}</Table.HeaderCell>
            <Table.HeaderCell style={{ width: "85px" }} />
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {docInfoItems && docInfoItems.length > 0 && docInfoItems.map( function(object: any, i: any) {
              const docObj = {...object, key: object.documentId ?? i} ;
              const btnLoading = (!!loadingBtn && object.documentId === selectedRowDocId) ? loadingBtn : "";
              return (
                <DocumentRow
                  key={docObj.key}
                  obj={docObj}
                  btnLoading={btnLoading}
                  deleteDoc={() => deleteDocument(docObj.documentId, docObj.fileName, docObj.caregiverId, docObj.recipientId)}
                  downloadDoc={() => downloadDocument(docObj.documentId, docObj.fileName, docObj.caregiverId, docObj.recipientId, docObj.fileType)}
                />
              );
            }
          )}

        </Table.Body>
      </Table>
    </Segment>
    </>
  );
};

export default observer(DocumentTable);
